import { InputModel } from '../components/input/input.model';
import { stringify } from '@angular/core/src/util';
import { StringUtils } from '../helpers/stringUtils';
import { AddressNumberModel } from '../components/input/rules/implementations/addressNumber.model';
import { AddressCepModel } from '../components/input/rules/implementations/addressCep.model';

export class AddressModel {
  logradouro: string;
  numero: string;
  complemento: string;
  bairro: string;
  cidadeNome: string;
  CEP: string;
  estadoUF: string;
  cidadeId: string;

  logradouroInputModel = new InputModel(false, false, 'text', 'Endereço', [], null);
  numeroInputModel = new InputModel(false, true, 'text', 'Numero', [], new AddressNumberModel());
  complementoInputModel = new InputModel(false, true, 'text', 'Complemento', [], null);
  bairroInputModel = new InputModel(false, false, 'text', 'Bairro', [], null);
  cidadeNomeInputModel = new InputModel(false, true, 'text', 'Cidade', [], null);
  CEPInputModel = new InputModel(false, false, 'tel', 'CEP', [], new AddressCepModel());
  estadoUFInputModel = new InputModel(false, true, 'text', 'Estado', [], null);

  static fromJsonToAddress(jsonAddress): AddressModel {
    const address = new AddressModel();

    address.logradouro = jsonAddress.logradouro;
    address.numero = jsonAddress.numero;
    address.complemento = jsonAddress.complemento;
    address.bairro = jsonAddress.bairro;
    address.cidadeNome = jsonAddress.cidadeNome;
    address.CEP = jsonAddress.CEP;
    address.estadoUF = jsonAddress.estadoUF;
    address.cidadeId = jsonAddress.cidadeId;

    return address;
  }

  public isComplete(): boolean {
    return (!StringUtils.isNullOrEmpty(this.logradouro)
      && !StringUtils.isNullOrEmpty(this.bairro)
      && !StringUtils.isNullOrEmpty(this.cidadeNome)
      && !StringUtils.isNullOrEmpty(this.CEP)
      && !StringUtils.isNullOrEmpty(this.estadoUF)
    );
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/models/address.model.ts